import { Hammer, ExternalLink, Image, Mic, Film, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const tools = [
  {
    name: "OpenArt",
    description: "AI image generation for thumbnails, channel art, and video assets.",
    icon: Image,
    iconColor: "text-purple-400",
    iconBg: "bg-purple-500/20",
    url: "https://openart.ai/home/?via=fint",
    category: "AI Art",
  },
  {
    name: "ElevenLabs",
    description: "Professional AI voiceover for your videos. Multiple voices and languages.",
    icon: Mic,
    iconColor: "text-blue-400",
    iconBg: "bg-blue-500/20",
    url: "https://try.elevenlabs.io/tcc3g77xuya2",
    category: "Voice AI",
  },
  {
    name: "CapCut",
    description: "Free, powerful video editor. Perfect for Shorts and long-form content.",
    icon: Film,
    iconColor: "text-pink-400",
    iconBg: "bg-pink-500/20",
    url: "https://www.capcut.com",
    category: "Editing",
  },
  {
    name: "Hera AI (15% off)",
    description: "AI-powered motion graphics prompt generator for stunning visual effects.",
    icon: Sparkles,
    iconColor: "text-amber-400",
    iconBg: "bg-amber-500/20",
    url: "https://hera.cello.so/EpChUOxiBIV",
    category: "Motion Graphics",
  },
];

export default function Tools() {
  return (
    <div className="p-6 md:p-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 rounded-xl bg-slate-500/20 flex items-center justify-center">
          <Hammer className="w-6 h-6 text-slate-400" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold">Tools & Software</h1>
          <p className="text-muted-foreground">Recommended tools for content creation</p>
        </div>
      </div>

      {/* Tools Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl">
        {tools.map((tool, i) => (
          <div key={i} className="glass-card p-6 flex flex-col">
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 rounded-xl ${tool.iconBg} flex items-center justify-center`}>
                <tool.icon className={`w-6 h-6 ${tool.iconColor}`} />
              </div>
              <span className="text-xs bg-muted px-2 py-1 rounded-full text-muted-foreground">
                {tool.category}
              </span>
            </div>
            <h2 className="font-display text-lg font-semibold text-foreground mb-2">
              {tool.name}
            </h2>
            <p className="text-sm text-muted-foreground mb-4 flex-1">
              {tool.description}
            </p>
            <Button variant="outline" className="w-full" asChild>
              <a href={tool.url} target="_blank" rel="noopener noreferrer">
                <ExternalLink className="w-4 h-4 mr-2" />
                Open Tool
              </a>
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}